/**
 * Hybrid SpotIllustration Component
 *
 * SpotIllustration's public props are just `React.ComponentPropsWithoutRef<"svg">`
 * — it exposes no styled-system props, so a `hasStyledProps` branch would be dead
 * code. This Hybrid is therefore a thin passthrough to the Tailwind implementation,
 * kept for parity with the other migrated components.
 */

import React from "react";
import { SpotIllustrationTailwind } from "./SpotIllustrationTailwind";
import type { TypeSpotIllustrationProps } from "./SpotIllustrationTypes";

const SpotIllustration = (props: TypeSpotIllustrationProps) => (
  <SpotIllustrationTailwind {...props} />
);

export default SpotIllustration;
